import type { MedalTier } from "@dailywars/core/medals";

import { cn } from "#/lib/utils";

const MEDAL_SRC: Record<MedalTier, string> = {
  gold: "/medals/gold.svg",
  silver: "/medals/silver.svg",
  bronze: "/medals/bronze.svg",
};

const MEDAL_LABEL: Record<MedalTier, string> = {
  gold: "Gold medal",
  silver: "Silver medal",
  bronze: "Bronze medal",
};

export function MedalIcon({
  tier,
  className,
  size = 16,
}: {
  tier: MedalTier;
  className?: string;
  size?: number;
}) {
  return (
    <img
      src={MEDAL_SRC[tier]}
      alt={MEDAL_LABEL[tier]}
      width={size}
      height={size}
      className={cn("inline-block shrink-0", className)}
      draggable={false}
    />
  );
}
